import type { IconSvgObject } from './types';

const CopyIcon: IconSvgObject = [
  ["path", { d: "M7 16V4C7 2.89543 7.89543 2 9 2H19C20.1046 2 21 2.89543 21 4V16C21 17.1046 20.1046 18 19 18H9C7.89543 18 7 17.1046 7 16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 6V20C3 21.1046 3.89543 22 5 22H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CopyIcon;
